import React from 'react';

import Base from './Base.jsx';

import ArticleReactionSinglePost from '../Components/ArticleReactionSinglePost/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-article-reaction';
  }

  renderElement(element) {
    var slug = element.dataset.slug;

    return (
      <ArticleReactionSinglePost articleSlug={slug} />
    );
  }
}


export default EntryPoint;

